import Flex from '@talkdesk/cobalt-react-flex'
import context from '../../config/context'
import AccountRecoveryNavbar from '../AccountRecoveryNavbar'
import AccountRecoveryFooter from '../AccountRecoveryFooter'
import { Center } from '../Wrappers'

/** @param {{ navbarActionElement?: any, pageHeader?: any, children?: any }} props */
const AccountRecoveryBase = ({ navbarActionElement, pageHeader, children }) => (
  <Flex direction='column' width='100vw' height='100vh'>
    <AccountRecoveryNavbar actionElement={navbarActionElement} />
    {pageHeader}
    <Flex direction='column' width='100%' grow scrollable>
      {children}
    </Flex>
    <AccountRecoveryFooter
      showGoogleFooterLink={context.showGoogleFooterLink}
    />
  </Flex>
)

const Centered = ({ children, ...props }) => (
  <AccountRecoveryBase {...props}>
    <Center>{children}</Center>
  </AccountRecoveryBase>
)

AccountRecoveryBase.Centered = Centered

export default AccountRecoveryBase
